import React from "react";
interface props {
  className?: string;
}
import TiltArrow from "../../../icons/TiltArrow";
import HomeIconSvg from "../../../icons/HomeIconSvg";
import UserIcon from "../../../icons/UserIcon";
import BankIcon from "../../../icons/BankIcon";

export const PostPropertyCard = ({ className }: props) => {
  return (
    <div className={` ${className}`}>
      {/* heading */}
      <p className="font-openSans font-semibold text-web-h3 leading-[26px] text-brand-textBlack">
        Post your properties as
      </p>
      {/* Owner */}
      <div className="flex items-center pt-[23px] pb-[19px] pl-[18px] border-b-[1px] border-[#A1A0A0] border-opacity-20 mt-[23px]">
        <UserIcon
          height="38px"
          width="38px"
          bgfill="#F1EAFF"
          iconfill="#FF752C"
        />
        <div className="mx-auto ml-[30px]">
          <p className="font-openSans font-semibold text-web-subheading leading-6 text-brand-textGrey">
            Owner
          </p>
          <p className="font-openSans font-normal text-web-body-md leading-4 text-brand-textGrey">
            8799+ properties posted
          </p>
        </div>
        <a href="/post-your-property?user_type=owner">
          <TiltArrow
            height="42px"
            width="42px"
            className="stroke-brand-bgBlack"
          />
        </a>
      </div>
      {/* Banker */}
      {/* <div className="flex items-center pt-[23px] pb-[19px] pl-[18px] border-b-[1px] border-[#A1A0A0] border-opacity-20 mt-[13px]">
        <BankIcon height="38px" width="38px" />
        <div className="mx-auto ml-[30px]">
          <p className="font-openSans font-semibold text-web-subheading leading-6 text-brand-textGrey">
            Banker
          </p>
          <p className="font-openSans font-normal text-web-body-md leading-4 text-brand-textGrey">
            8799+ properties posted
          </p>
        </div>
        <a href="/">
          <TiltArrow
            height="42px"
            width="42px"
            className="stroke-brand-bgBlack"
          />
        </a>
      </div> */}
      {/* Agent */}
      <div className="flex items-center pt-[23px] pb-[19px] pl-[18px] mt-[13px]">
        <HomeIconSvg height="38px" width="38px" bgfill="#F1EAFF" />
        <div className="mx-auto ml-[30px]">
          <p className="font-openSans font-semibold text-web-subheading leading-6 text-brand-textGrey">
            Agent
          </p>
          <p className="font-openSans font-normal text-web-body-md leading-4 text-brand-textGrey">
            8799+ properties posted
          </p>
        </div>
        <a href="/post-your-property?user_type=property_agent">
          <TiltArrow
            height="42px"
            width="42px"
            className="stroke-brand-bgBlack"
          />
        </a>
      </div>
    </div>
  );
};
